import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessHealthMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-health-metadata/business-health-metadata.component.abstract';
import { SharedBusinessMetadataV2Component } from '../shared-business-metadata-v2/shared-business-metadata-v2.component';

@Component({
  selector: 'app-business-health-metadata-v2',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    CustomDatePipe,
    SharedBusinessMetadataV2Component,
  ],
  templateUrl: './business-health-metadata-v2.component.html',
})
export class BusinessHealthMetadataV2Component extends BusinessHealthMetadataComponentAbstract {}
